import { Router } from '@angular/router';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventsService, PaymentV2Service, UtilService, VariablesService } from '../../shared/services';
@Component({
  selector: 'app-otd-to-sip',
  templateUrl: './otd-to-sip.component.html',
  styleUrls: ['./otd-to-sip.component.scss'],
})
export class OtdToSipComponent implements OnInit, OnDestroy {

  @Input() config;
  currency;
  subs: Subscription[] = [];
  livesChanged;
  livesChanged1;
  userData;
  sipDonors;
  isSipSubscribed = false;

  public list = [
    { label: `Save 12 lives / year` },
    { label: `` },
    { label: `80G tax savings` },
    { label: `New rewards every month` },
    { label: `Track your impact` },
  ];

  constructor(
    public utilService: UtilService,
    public paymentV2: PaymentV2Service,
    public eventsService: EventsService,
    public variablesService: VariablesService,
    public router: Router
  ) { }

  ngOnInit() {
    this.variablesService.getSubsCount();
    this.subs.push(this.utilService.currency.subscribe(res => {
      this.currency = res;
      this.list[1] = { label: `Donations starting @ ${this.paymentV2.getMinSipAmount(this.currency)?.text} / month` };
    }));
    this.subs.push(this.variablesService.subsCount.subscribe((res: any) => {
      this.sipDonors = res;
    }));
    this.subs.push(this.variablesService.userData.subscribe({
      next: (res) => {
        this.isSipSubscribed = [1, 2].includes(res?.listsubscriptions?.medical?.status_flag);
        this.userData = res;
        this.livesChanged = `Your support changed ` + `<strong>${this.userData?.aggdonationall?.funds}${this.userData?.aggdonationall?.funds === 1 ? ' life ' : ' lives '}</strong>` + `forever. Make your impact monthly now.`;
      }
    }));
  }

  redirect(value) {
    if (!this.userData) {
      if (this.router.url.match('stories')) {
        this.utilService.redirectWithUTM('new/sip', { utm_term: 'storysip', utm_content: value === 'banner' ? 'topbanner' : 'pitchcard' });
      } else {
        this.utilService.redirectWithUTM('new/sip', { utm_term: 'fundraisersip', utm_content: value === 'banner' ? 'topbanner' : 'pitchcard' });
      }
      this.utilService.scrollToTop();
    } else {
      if (this.router.url.match('stories')) {
        this.utilService.router.navigate(['/new/sip/payment-standalone'],
          {
            queryParams: { currency: this.currency, amount: this.paymentV2.getMinSipAmount(this.currency).amount, utm_term: 'storysip', utm_content: value === 'banner' ? 'topbanner' : 'pitchcard' }, queryParamsHandling: 'merge'
          });
      } else {
        this.utilService.router.navigate(['/new/sip/payment-standalone'],
          {
            queryParams: { currency: this.currency, amount: this.paymentV2.getMinSipAmount(this.currency).amount, utm_term: 'fundraisersip', utm_content: value === 'banner' ? 'topbanner' : 'pitchcard' }, queryParamsHandling: 'merge'
          });
      }
    }
    const payload = {
      eventName: 'otdtosip',
      page_name: this.variablesService.pageName,
    };
    if (value === 'banner') {
      payload['info_1'] = 'Banner';
    }
    if (value === 'pitchcard') {
      payload['info_1'] = 'Pitchcard';
    }
    this.eventsService.sendSystemEvent(payload).subscribe();
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}